import styled from "styled-components";

export const StyledSwiperWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);

  & .swiper {
    max-width: 100% !important;
  }
`;